module.exports = __webpack_public_path__ + "static/img/4.dab4e62.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/sp/4.png
// module id = AIHV
// module chunks = 0